// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const removeKeyFromObject = (key: string, { [key]: _, ...rest }) => rest;
